import { IMeasurementBodyContext } from 'types/models/TrackingDiagnosticsModel';

interface IRawInfoContext {
    MeasurementBody?: {
        SessionId?: string | null;
        MeasurementId?: string | null;
        CalibrationId?: string | null;
    } | null;
}

const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

function toGuidOrNull(value: string | null | undefined): string | null {
    if (!value || value === EMPTY_GUID) return null;
    return value;
}

export function parseMeasurementBody(rawInfoContext: string | null | undefined): IMeasurementBodyContext {
    if (!rawInfoContext) return { sessionId: null, measurementId: null, calibrationId: null };

    let parsed: IRawInfoContext;
    try {
        parsed = JSON.parse(rawInfoContext);
    } catch {
        return { sessionId: null, measurementId: null, calibrationId: null };
    }

    const body = parsed?.MeasurementBody;
    if (!body || typeof body !== 'object') return { sessionId: null, measurementId: null, calibrationId: null };

    return {
        sessionId: toGuidOrNull(body.SessionId),
        measurementId: toGuidOrNull(body.MeasurementId),
        calibrationId: toGuidOrNull(body.CalibrationId),
    };
}

export function isMeasurementBodyParseable(rawInfoContext: string | null | undefined): boolean {
    const { sessionId, measurementId, calibrationId } = parseMeasurementBody(rawInfoContext);
    return sessionId !== null && measurementId !== null && calibrationId !== null;
}
